var _rect, _path, _path2, _path3, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuBudgetHovered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 31,
    height: 31,
    rx: 3.5,
    fill: "#FFA979"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 3.5C17.8954 3.5 17 4.39543 17 5.5V13.5C17 14.6046 17.8954 15.5 19 15.5H27C28.1046 15.5 29 14.6046 29 13.5V5.5C29 4.39543 28.1046 3.5 27 3.5H19ZM27 9.5C27 8.94772 26.5523 8.5 26 8.5L20 8.5C19.4477 8.5 19 8.94772 19 9.5C19 10.0523 19.4477 10.5 20 10.5H26C26.5523 10.5 27 10.0523 27 9.5Z",
    fill: "#FCFCFC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 17.5C3.89543 17.5 3 18.3954 3 19.5V27.5C3 28.6046 3.89543 29.5 5 29.5H13C14.1046 29.5 15 28.6046 15 27.5V19.5C15 18.3954 14.1046 17.5 13 17.5H5ZM7.58577 26.3284C7.19524 26.7189 6.56208 26.7189 6.17156 26.3284C5.78103 25.9379 5.78103 25.3047 6.17156 24.9142L7.58582 23.4999L6.17168 22.0858C5.78116 21.6953 5.78116 21.0621 6.17168 20.6716C6.56221 20.2811 7.19537 20.2811 7.5859 20.6716L9.00003 22.0857L10.4142 20.6716C10.8047 20.281 11.4379 20.281 11.8284 20.6716C12.2189 21.0621 12.2189 21.6952 11.8284 22.0858L10.4142 23.4999L11.8285 24.9142C12.2191 25.3047 12.2191 25.9379 11.8285 26.3284C11.438 26.719 10.8048 26.719 10.4143 26.3284L9.00003 24.9141L7.58577 26.3284Z",
    fill: "#FCFCFC"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3.5C3.89543 3.5 3 4.39543 3 5.5V13.5C3 14.6046 3.89543 15.5 5 15.5H13C14.1046 15.5 15 14.6046 15 13.5V5.5C15 4.39543 14.1046 3.5 13 3.5H5ZM19 17.5C17.8954 17.5 17 18.3954 17 19.5V27.5C17 28.6046 17.8954 29.5 19 29.5H27C28.1046 29.5 29 28.6046 29 27.5V19.5C29 18.3954 28.1046 17.5 27 17.5H19ZM9 13.5C9.55229 13.5 10 13.0523 10 12.5V10.5H12C12.5523 10.5 13 10.0523 13 9.5C13 8.94772 12.5523 8.5 12 8.5H10V6.5C10 5.94772 9.55229 5.5 9 5.5C8.44772 5.5 8 5.94772 8 6.5L8 8.5H6C5.44772 8.5 5 8.94772 5 9.5C5 10.0523 5.44771 10.5 6 10.5H8V12.5C8 13.0523 8.44772 13.5 9 13.5ZM26.5355 19.9646C26.145 19.574 25.5118 19.574 25.1213 19.9646L19.4644 25.6214C19.0739 26.0119 19.0739 26.6451 19.4644 27.0356C19.8549 27.4261 20.4881 27.4261 20.8786 27.0356L26.5355 21.3788C26.926 20.9882 26.926 20.3551 26.5355 19.9646Z",
    fill: "#FCFCFC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 31,
    height: 31,
    rx: 3.5,
    stroke: "#FD7123"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBudgetHovered);
export default __webpack_public_path__ + "static/media/menu-budget-hovered.5296b01c152e5b1b76c848fce2e8b1cb.svg";
export { ForwardRef as ReactComponent };